import { ApiRoutesModel } from "../../app/core/models/apiRoutesModel";

export const ApiRoutes: ApiRoutesModel = {
  auth: {
    login: 'login',
    logout: 'logout',
    socialLogin: 'oauth2login',
    socialSignup: 'oauth2user'
  },
  inr: {
    patientsWithInr: 'dashboard/inr/patients',
    updateStatus: 'inr/update-status',
    requestDocuments: 'dashboard/inr/requests/documents',
    submitResponse: 'dashboard/inr',
    assign: 'dashboard/inr/assign'
  },
  applications: {
    patientData: 'patientdata',
    paginatedData: 'dashboard/patients',
    mrnUpdate: 'dashboard',
    documents: 'applicationdocument/documents',
    setName: 'patientdata/patientname'
  },
}
